








import {Component, Vue} from 'vue-property-decorator';
import EmptyPage from '@v/EmptyPageView.vue';

@Component({
  components: {
    EmptyPage,
  },
})
export default class ErrorLayout extends Vue {}
